import { useTheme } from '@simplywallst/ui-core';

import type { Category } from '../../query';

import { getCategoryColor } from '../../utils/getCategoryColor';

interface Props {
  y: number;
  date: number;
  onClick: (data: { id: string; date: number }) => void;
  events?: { id: string; category: Category }[];
}

const PriceChartEventMarker = ({ y, date, onClick, events }: Props) => {
  const theme = useTheme();
  if (typeof events === 'undefined') return null;
  return (
    <g cursor="pointer" transform={`translate(0,${y})`}>
      {events.map((event, i) => {
        return (
          <g
            data-cy-id={`price-chart-event-marker-${event.id}`}
            key={`${event.id}-${i}`}
            transform={`translate(0,${i * 5})`}
          >
            <circle
              cx="0"
              cy="0"
              fill={theme.color[getCategoryColor(event.category)]}
              r="5"
              onClick={() => onClick({ id: event.id, date })}
            />
          </g>
        );
      })}
    </g>
  );
};

export default PriceChartEventMarker;
